import VueRouter from 'vue-router';
import Error from '../../action/error';

let routes = [
    {
        path: '/',
        component: require('../views/list').default
    },
    {
        path: '/:id',
        component: require('../views/details').default
    },
];

export default new VueRouter({
    routes,
    linkExactActiveClass: 'active'
});
